import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';
import { CONSTANTS } from 'src/app/constants';
import { ApiService } from 'src/app/shared/service/api.service';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import { PoTableColumn } from '@po-ui/ng-components';

@Component({
  selector: 'app-selling-products',
  templateUrl: './selling-products.component.html',
  styleUrls: ['./selling-products.component.css']
})
export class SellingProductsComponent implements OnInit {
  tableItens = new Array();
  totalSales!: string;
  tableDataRow!: any;
  loading: boolean = true;
  errorApi: boolean = false;
  message: string = '';
  dateFirst!: any;
  productSelected!: number;
  listProduct: any = [];
  paramRouter: any;
  topTooltip: string = 'Produtos mais vendidos de todas as filiais';
  topTooltipExcel: string = 'Download .xlsx';
  columns: Array<PoTableColumn> = [
    { property: 'descricao', label: 'Descrição', type: 'string' },
    { property: 'qtd', label: 'QT Pçs', type: 'number' },
    { property: 'valorMedio', label: 'Valor Médio', type: 'currency', format: 'BRL' },
    { property: 'valorVenda', label: 'Valor Venda', type: 'currency', format: 'BRL' }
  ];

  @Output() errorEmitter = new EventEmitter();

  constructor(private router: Router, private api: ApiService, private route: ActivatedRoute) { }

  ngOnInit() {
    this.loading = true;
    this.api.setHeader();
    this.route.queryParams.subscribe((item: any) => {
      this.paramRouter = item;
    })
    this.selectProduct().subscribe(data => {
      try {
        if (data.dataRow.length != 0) {
          data.dataRow.map((el: any, index: any) => {
            this.listProduct.push({ value: index, label: el.classification_type_name, type: el.classification_type_code });
          })
          let branchParam: any = [];
          this.paramRouter.branch == 'null' ? branchParam = [] : branchParam = this.paramRouter.branch;
          this.productSelected = parseInt(this.paramRouter.value);
          this.topTooltip = 'Produtos mais vendidos de todas as filiais durante o período de ' + moment(this.paramRouter.dateMin).format('DD/MM/YYYY') + ' à ' + moment(this.paramRouter.dateMax).format('DD/MM/YYYY') 
          let objFilter = {
            dataMin: this.paramRouter.dateMin,
            dataMax: this.paramRouter.dateMax,
            branch: branchParam,
            type: parseInt(this.paramRouter.type),
            sellers: []
          }
          this.productList(objFilter); 
        } else {
          this.message = CONSTANTS.MESSAGES.DATA_NULL_SELLING_PRODUCTS;
          this.formatErrorMensagem(this.message);
          this.errorApi = true;
        }
      } catch (error: unknown) {
        this.loading = false;
        this.errorApi = true;
        this.message = CONSTANTS.MESSAGES.DATA_ERRO_SELLING_PRODUCTS;
        if (error instanceof Error)
          this.formatErrorMensagem(error.message);
      }
    }, error => {
      this.loading = false;
      this.errorApi = true;
      this.message = CONSTANTS.MESSAGES.DATA_ERRO_SELLING_PRODUCTS;
      this.formatErrorMensagem(error.message);
    });
  }

  getTotal() {
    let arrayTotal = new Array();
    this.tableDataRow.map((el: any) => {
      arrayTotal.push(el.invoice_value);
    })
    let total = arrayTotal.reduce((total: any, numero: any) => {
      return parseFloat(total) + parseFloat(numero);
    }, 0);
    return total.toLocaleString('pt-br', { minimumFractionDigits: 2 });
  }

  getTable(item: any) {
    this.totalSales = this.getTotal();
    let orderTable = item.sort((a: any, b: any) => parseInt(a.product_sale_qty) - parseInt(b.product_sale_qty));
    orderTable = orderTable.reverse();
    this.tableItens = [];
    let excelInfo: any = [];
    let trataDivisao = 0;
    orderTable.map((el: any) => {
      parseInt(el.item_quantity) === 0 ? trataDivisao = 0 : trataDivisao = parseFloat((el.invoice_value / parseInt(el.item_quantity)).toFixed(2));
      excelInfo.push({'Classificação': this.listProduct[this.productSelected].label, 'Descrição': el.classification_name, 'QT Pçs': parseInt(el.item_quantity), 'Valor Médio R$': trataDivisao.toLocaleString('pt-BR', {minimumFractionDigits: 2}), 'Valor Venda R$': el.invoice_value.toLocaleString('pt-BR', {minimumFractionDigits: 2})});
      this.tableItens.push({
        descricao: el.classification_name === null ? 'Item sem descrição' : el.classification_name,
        qtd: el.item_quantity === null ? 'Item sem qtd. peças' : parseInt(el.item_quantity),
        valorMedio: trataDivisao,
        valorVenda: el.invoice_value,
      })
    });
    excelInfo.unshift({});
    localStorage.setItem('selling-products', JSON.stringify(excelInfo));
    this.loading = false;
  }

  downloadExcel() {
    const EXCEL_TYPE =
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const EXCEL_EXTENSION = '.xlsx';

    let dataSellingProducts = [];
    let objectSellingProducts = localStorage.getItem('selling-products');

    objectSellingProducts != null
      ? (dataSellingProducts = JSON.parse(objectSellingProducts))
      : (dataSellingProducts = []);
    const worksheetSellingProducts= XLSX.utils.json_to_sheet(dataSellingProducts);

    const workbook = {
      Sheets: {
        'produtos-mais-vendidos': worksheetSellingProducts,
      },
      SheetNames: [
        'produtos-mais-vendidos',
      ],
    };
    const excelBuffer: any = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'buffer',
    });
    const data: Blob = new Blob([excelBuffer], {
      type: EXCEL_TYPE,
    });
    FileSaver.saveAs(data, 'minhas-operacoes-produtos-mais-vendidos' + EXCEL_EXTENSION);
  }

  recoverProduct(item: any) {
    this.loading = true;
    this.productSelected = parseInt(item);
    let typeSelected = this.listProduct[item].type;
    let objFilter = {
      dataMin: this.paramRouter.dateMin,
      dataMax: this.paramRouter.dateMax,
      branch: this.paramRouter.branch,
      type: typeSelected,
      sellers: []
    }
    this.productList(objFilter);
  }

  productList(item: any) {
    this.topProduct(item).subscribe(data => {
      try {
        if (data.dataRow.length != 0) {
          this.tableDataRow = data.dataRow;
          this.getTable(this.tableDataRow);
        } else {
          this.message = CONSTANTS.MESSAGES.DATA_NULL_SELLING_PRODUCTS;
          this.formatErrorMensagem(this.message);
          this.loading = false;
          this.errorApi = true;
        } 
      } catch (error) {
        this.loading = false;
        this.errorApi = true;
        this.message = CONSTANTS.MESSAGES.DATA_ERRO_SELLING_PRODUCTS;
        if (error instanceof Error)
          this.formatErrorMensagem(error.message);
      }
    }, error => {
      this.loading = false;
      this.errorApi = true;
      this.message = CONSTANTS.MESSAGES.DATA_ERRO_SELLING_PRODUCTS;
      this.formatErrorMensagem(error.message);
    });
  }

  backHome() {
    this.router.navigate(['/home/sale']);
  }

  selectProduct() {
    return this.api.getClassificationTypes();
  }

  topProduct(item: any) {
    return this.api.postClassificationProduct(item.dataMin, item.dataMax, item.branch, item.sellers, item.type);
  }

  formatErrorMensagem(item: any) {
    let dataError = new Date();
    let errorMensagem = "Arquivo: selling-products \r\n" + "Data: " + dataError + "\r\n" + "Mensagem: " + item + "\r\n" + "===============================================" + "\r\n";
    this.errorEmitter.emit(errorMensagem);
  }
}
